export const XmlConstant = {
    version: "1.0",
    encoding: "UTF-8",
};
export const LandXmlConstant = {
    xsi: "http://www.w3.org/2001/XMLSchema-instance",
    schemaLocation: "http://www.landxml.org/schema/LandXML-1.2 http://www.landxml.org/schema/LandXML-1.2/LandXML-1.2.xsd",
    date: "2020-05-30",
    time: "13:56:35",
    version: "1.2",
    language: "Japanese",
    readOnly: "false",
    xmlns: "http://www.landxml.org/schema/LandXML-1.2",
};
export const MetricConstant = {
    areaUnit: "squareMeter",
    linearUnit: "meter",
    volumeUnit: "cubicMeter",
    temperatureUnit: "celsius",
    pressureUnit: "milliBars",
    angularUnit: "decimal degrees",
    directionUnit: "decimal degrees",
};
export const XmlApplication = {
    name: "KomConnect",
    manufacturer: "コマツ",
    manufacturerURL: "http://www.komatsu.co.jp/",
};
//# sourceMappingURL=xml-constants.js.map